/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import moment from 'jalali-moment'

import Leaflet from 'leaflet'

import Menu from '../../../components/Menu'

import { get } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { useParams } from 'react-router'

import { ToastContainer } from 'react-toastify'

import foodIcon from '../../../assets/svg/orderIcon.svg'
import { ToRial } from '../../../services/toRial'

import iconUrl from '../../../assets/svg/Location.svg'

import { MapContainer, TileLayer, Marker } from 'react-leaflet'

import { useNavigate } from 'react-router-dom'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

export default function index() {
  document.title = 'سفارش'
  const { id } = useParams()
  const navigate = useNavigate()

  const [order, setOrder] = useState([])
  const [basket, setBasket] = useState([])
  const [user, setUser] = useState([])
  const [branch, setBranch] = useState([])
  const [orderWay, setOrderWay] = useState([])
  const [orderStatus, setOrderStatus] = useState('')
  const [mapDetails, setMapDetails] = useState([37.27579, 49.937])

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/order/${id}?token=${token}`)
      .then(response => {
        setOrder(response.data.data)
        setBasket(response.data.data.basket)
        setUser(response.data.data.user)
        setBranch(response.data.data.branch)
        setOrderWay(response.data.data.orderWay)
        setMapDetails(response.data.data.orderWay.orderDetail.selectedPosition)

        switch(response.data.data.orderStatus) {
          case 'new':
            setOrderStatus('سفارش جدید')
            break
          case 'doing':
            setOrderStatus('سفارش در حال انجام')
            break
          case 'ready':
            setOrderStatus('سفارش آماده تحویل')
            break
          case 'done':
            setOrderStatus('تحویل داده شده')
            break
          case 'cancel':
            setOrderStatus('سفارش کنسل شده')
            break
          default :
            setOrderStatus('')
            break
        }
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [id, token])

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'order'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
        <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                سفارش
              </div>
            </div>

            <div className="left">
              <button onClick={() => navigate(-1)}>برگشت</button>
            </div>
          </div>
          <div className='form'>
            <div className='title'>
              سفارش شماره : {order.orderNumber} - وضعیت سفارش : {orderStatus}
            </div>
            <div className='lineTitleFood'>
              <hr />
                اطلاعات سفارش
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>تاریخ خرید :</label>
                <div className='text'>{moment(order.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>پرداخت :</label>
                <div className='text'>{order.payStatus ? (
                  <div className="success">پرداخت شده  - آیدی پرداخت : {order.refId}</div>
                ) : (
                  <div className="failed">پرداخت نشده  - آیدی پرداخت : -</div>
                )}</div>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>جمع سبد خرید :</label>
                <div className='text'>{ToRial(String(order.productsTotal))} تومان</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>هزینه ارسال :</label>
                <div className='text'>{ToRial(String(order.shippingCost))} تومان</div>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>هزینه کل :</label>
                <div className='text'>{ToRial(String(order.total))} تومان</div>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>کد تخفیف :</label>
                <div className='text'>{ToRial(String(order.totalDiscount))} تومان - '{order.discount}'</div>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>سبد خرید :</label>
                <ul className='list'>
                  {basket ? basket.map(item => (
                    <li key={item._id}>{item.name} - تعداد : ({item.count}) - قیمت هر واحد : ({ToRial(String(item.price))}) - قیمت کل : ({ToRial(String(item.allPrice))})</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>مشخصات خریدار :</label>
                <ul className='list'>
                  {user ? user.map(item => (
                    <li key={item._id}>{item.name} - 0{item.phoneNumber}</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>خرید از شعبه :</label>
                <ul className='list'>
                  {branch ? branch.map(item => (
                    <li key={item._id}>{item.name} - {item.description}</li>
                  )) : ''}
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>نحوه ارسال :</label>
                <ul className='list'>
                  <li>{orderWay.type === 'peyk' ? 'پیک' : 'حضوری'} - {orderWay.type === 'peyk' ? 'آدرس : ' + orderWay.orderDetail.addressSelect + ' - پلاک : ' + orderWay.orderDetail.plak : orderWay.orderDetail}</li>
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>زمان تحویل:</label>
                <ul className='list'>
                  <li>{order.timeDeliver}</li>
                </ul>
              </div>
            </div>
            <div className='map' style={{ margin: '1em 0' }}>
              {orderWay.type === 'peyk' ? <MapContainer center={mapDetails.length > 0 ? [mapDetails[0], mapDetails[1]] : []} zoom={16} scrollWheelZoom={false}>
                <Marker icon={newicon} position={mapDetails ? [mapDetails[0], mapDetails[1]] : [37.27579, 49.937]} />
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </MapContainer> : ''}
            </div>
          </div>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}